
<div class="address-list" *ngIf="addresses" [class.empty]="addresses.length == 0"><span class="inid">{{ inid || '-' }}</span><span class="label">{{ inidLabel }}</span>
  <ul>
    <li class="content" *ngFor="let a of addresses; let i = index"><span>- {{ a.fullName.content }} ⫯ city, {{ a.countryCode.content }} </span><br></li>
  </ul>
</div>
